import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SetCountryService} from 'src/app/data/utils/set-country.service';
import {RequestService} from '../../../handlers/request/request.service';
import {globalEnv} from '../../connection/global/global.env';
import {
  iDataUserRegistrationExpress,
  iDocumentTypesResponse,
  iRegistrationExpressCodeResponse,
  iRegistrationExpressValidateCode,
} from '../../models/registration-express/registration-express';
import {registrationExpressEndpoints} from '../../api/registration-express/registration-express';

@Injectable({
  providedIn: 'root',
})
export class RegistrationExpressService {
  constructor(private req: RequestService, private setCountryService: SetCountryService) {}

  validateCode(
    data: iRegistrationExpressValidateCode,
  ): Observable<iRegistrationExpressCodeResponse> {
    const endPoint = this.setCountryService.changeUrl(registrationExpressEndpoints.validateCode);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null, false);
  }

  saveUserExpress(
    data: iDataUserRegistrationExpress,
  ): Observable<iRegistrationExpressCodeResponse> {
    const endPoint = this.setCountryService.changeUrl(registrationExpressEndpoints.validateData);
    return this.req.post(`${globalEnv.multiCountry}${endPoint}`, data, null, null, false);
  }

  documentTypes(): Observable<iDocumentTypesResponse[]> {
    const endPoint = this.setCountryService.changeUrl(registrationExpressEndpoints.documentTypes);
    return this.req.get(`${globalEnv.multiCountry}${endPoint}`, null, null, false);
  }
}
